'use client';

import { useHeader } from '@larvitu/shared/react/context/feature-header-context';
import { AppBar, Box, Container } from '@mui/material';

import { StyledToolBar, ToolbarShadowStyle } from '../ToolBar';
import { ToolbarOffset } from '../ToolbarOffset';

import type { FC, ReactNode } from 'react';

export interface HeaderProps {
  transparent?: boolean;
  isScrolling?: boolean;
  children: ReactNode;
}

export const Header: FC<HeaderProps> = ({
  transparent,
  isScrolling,
  children,
}) => {
  const { height = 96 } = useHeader();

  return (
    <>
      <AppBar
        sx={{
          boxShadow: 0,
          bgcolor: transparent ? 'transparent' : 'white',
        }}
      >
        <StyledToolBar
          // variant="dense"
          disableGutters
          isTransparent={false}
          isScrolling={isScrolling}
        >
          <Container>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {children}
            </Box>
          </Container>
        </StyledToolBar>
      </AppBar>
      <ToolbarOffset />
    </>
  );
};
